import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Modal, Spin, Alert } from 'antd'
import { getIssueStageLogs } from '../../../../services/api/apiOrdersReport'

/**
 * @FAC-25799 — popup "Chi tiết sản xuất": user + thời gian từng công đoạn của mỗi barcode item.
 * BE (exporter-service POST /issues/stage-logs) luôn trả đủ 8 công đoạn theo thứ tự cố định,
 * FE chỉ hiện công đoạn item ĐÃ trải qua (có log). Trong một công đoạn log xếp mới → cũ
 * (item có thể được tái tạo và làm lại) nên hiện tất cả, gộp ô tên công đoạn bằng rowSpan.
 */
const ProductionDetailModal = ({ visible, onClose, referenceNumbers }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [items, setItems] = useState([])

    useEffect(() => {
        if (!visible) return
        let cancelled = false

        const _fetch = async () => {
            setLoading(true)
            setError('')
            setItems([])
            try {
                const { data: response } = await getIssueStageLogs({ reference_numbers: referenceNumbers })
                const { success, data, message } = Object.assign({}, response)
                if (!success) throw new Error(message || 'Không lấy được chi tiết sản xuất')
                if (!cancelled) setItems(Array.isArray(data) ? data : [])
            } catch (e) {
                if (!cancelled) setError(e.message)
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        _fetch()

        return () => {
            cancelled = true
        }
    }, [visible, referenceNumbers])

    const _getPassedStages = (item) => (item.stages || []).filter(stage => (stage.logs || []).length > 0)

    const _renderStageRows = (stage) => {
        const logs = stage.logs

        return (
            <React.Fragment key={stage.code}>
                {logs.map((log, i) => (
                    <tr key={i}>
                        {i === 0 &&
                            <td className="Stage" rowSpan={logs.length}>
                                {stage.name}
                                {stage.has_more && <div className="text-muted small font-weight-normal">(chỉ hiện {logs.length} lần gần nhất)</div>}
                            </td>
                        }
                        <td>{log.user || '—'}</td>
                        <td>{log.time ? moment(log.time).format('DD/MM/YYYY HH:mm') : '—'}</td>
                    </tr>
                ))}
            </React.Fragment>
        )
    }

    return (
        <Modal
            className="ProductionDetailModal"
            title={<span style={{ fontWeight: 'bold', fontSize: 20 }}>Chi tiết sản xuất</span>}
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={640}
        >
            <Spin spinning={loading}>
                {!!error && <Alert type="error" message={error} showIcon className="mb-2" />}
                {!loading && !error && items.length === 0 && <div className="text-muted">Không có dữ liệu</div>}
                {items.map(item => (
                    <div className="ProductionDetailItem" key={item.reference_number}>
                        <div className="font-weight-bold mb-1">#{item.reference_number}</div>
                        <table className="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>Công đoạn</th>
                                    <th>User</th>
                                    <th>Thời gian</th>
                                </tr>
                            </thead>
                            <tbody>
                                {_getPassedStages(item).length === 0
                                    ? <tr><td colSpan={3} className="text-muted">Item chưa có log công đoạn nào</td></tr>
                                    : _getPassedStages(item).map(_renderStageRows)
                                }
                            </tbody>
                        </table>
                    </div>
                ))}
            </Spin>
        </Modal>
    )
}

export default ProductionDetailModal
